module.exports = __webpack_public_path__ + "static/media/chinuri-yellow.f81be8e1.png";